import {Whatsapp, Mailbox, Check2Square, Trash} from "react-bootstrap-icons";
import {useEffect, useState} from "react";
import {useStore} from "../../store/store";
import "../../i18n";
import {useTranslation} from "react-i18next";
import axios from "axios";
import {APIBASE} from "../../config/Pfalzmarkt.config";

export default function MessageSettingsLine(props) {
    const t = useTranslation()[0];
    const [globalState, dispatch] = useStore();
    const header = "Authorization: Bearer " + localStorage.getItem("token");
    const[deleted, setDeleted] = useState(false);
    async function deleteSetting (settingId) {
            try {
                const response = await axios.get(
                    APIBASE + 'api/erzeuger/deleteSetting/' + settingId, {headers: header}
                );
                setDeleted(true);

            } catch (err) {
                dispatch('IS_401_ERROR', true);
                dispatch('SET_AUTHTOKEN', null);
                console.log(err); // Todo: Errorhandling
            }

    }

    useEffect(() => {

    }, [globalState.token]);

    return <>{!deleted && <>
        <div className="row">
            <div className="col-sm-6">
                <label className="form-label">
                    <select className="form-select" name="newSetting[]">
                        <option value="changedorder" selected={props.scope == 'changedorder'}> {t('changedorder')}</option>
                        <option value="neworder" selected={props.scope == 'neworder'}>{t('neworder')}</option>
                    </select>
                </label>
            </div>
        </div>
        <div className="row">
            <div className="col-sm-1">
                <input type="hidden" name="channel[]" value={props.channel}/>
                <input type="hidden" name="id[]" value={props.id}/>
                <select className="form-select" name="isdCode[]">
                    {props.isdCodes.map((code) => {
                        return <option key={code.id} value={code.id}
                                       selected={code.phoneCode == props.phoneCode}>+{code.phoneCode} ({code.countryName})</option>
                    })}
                </select>
            </div>
            <div className="col-sm-5">
            <input type="tel" className="form-control" name="addresses[]"
                       placeholder='123 456789'
                       defaultValue={props.value}
                       size="20"/>
            </div>
            <div className="col-sm-2">
                {props.validated && <Check2Square size="20"/>}<Trash onClick={() => {deleteSetting(props.id)}}/>
            </div>
        </div></>
    }</>;

}

